/* eslint-disable */
import { bus } from '@/main';
import toast from '@/services/toast';
export default {
  name: 'add-category-info-popup',
  components: {},
  props: [],
  data() {
    return {
      name: '',
      description: '',
      image: null,
      bg_image: null
    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    getCategoryAgain() {
      this.$store.dispatch('getCategoriesListAction');
    },
    PopupCloseMethod() {
      bus.$emit('addNewCategoryPopupStateBus', false);
    },
    handleImageUpload(event) {
      this.image = event.target.files[0];
      this.images = this.$refs.image.files[0];
    },
    handleBgImageUpload(event) {
      this.bg_image = event.target.files[0];
      this.bg_images = this.$refs.bg_image.files[0];
    },
    validateCreateCategoryBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let formData = new FormData();
          formData.append('name', this.name);
          formData.append('description', this.description);
          formData.append('image', this.images);
          formData.append('bg_image', this.bg_images);
          this.$store.dispatch('createNewCategoryList', formData)
            .then((res) => {
              if (res.status == '201') {
                toast.success(res.data.msg);
                this.getCategoryAgain();
                this.PopupCloseMethod();
              }
            })
          return
        }
      });
    },
  }
}